<div *ngIf="renderChart" class="w-full h-full">
    <si-seatsio-seating-chart #seats [config]="config"></si-seatsio-seating-chart>
</div>